module.exports = __webpack_public_path__ + "img/empty.5863f3d.svg";